export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20modern%20media%20broadcast%20studio%20interior%20with%20soft%20golden%20ambient%20lighting%2C%20large%20digital%20screens%20displaying%20abstract%20data%20visualizations%2C%20Chinese%20contemporary%20aesthetic%20design%2C%20cinematic%20atmosphere%20with%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field&width=1800&height=800&seq=hero-bg-2025&orientation=landscape"
        alt="国产传媒权威内容平台"
        title="国产传媒 - 权威内容平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 text-sm bg-white/15 backdrop-blur-sm text-white rounded-full mb-6 border border-white/20 whitespace-nowrap">
          专注本土内容创作与传播的核心平台
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white max-w-4xl leading-tight mb-6">
          汇聚优质国产内容<br className="hidden md:block" />
          助力品牌与创作者高效传播
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mb-8 leading-relaxed">
          覆盖影视、资讯、娱乐、科技、文化、商业六大领域，日触达用户超5000万，为创作者和品牌搭建高效传播桥梁
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            了解服务体系
          </Link>
          <a
            href="/about"
            className="px-8 py-3 border border-white/30 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            创作者入驻
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-14">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5000<span className="text-primary-400">万+</span></div>
            <div className="text-xs md:text-sm text-white/50 mt-1">日触达用户</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5<span className="text-primary-400">万+</span></div>
            <div className="text-xs md:text-sm text-white/50 mt-1">入驻创作者</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">30<span className="text-primary-400">+</span></div>
            <div className="text-xs md:text-sm text-white/50 mt-1">分发渠道</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">99.7<span className="text-primary-400">%</span></div>
            <div className="text-xs md:text-sm text-white/50 mt-1">内容审核准确率</div>
          </div>
        </div>
      </div>
    </section>
  );
}